import React, { type ReactElement } from "react"

import { useTranslation } from "react-i18next"

import CloseIcon from "@mui/icons-material/Close"
import { Drawer, Grid, IconButton } from "@mui/material"
import { Typography } from "@synapse-analytics/synapse-ui"

import { getTheme } from "../../../hooks/UseTheme"
import type { SelectedComponent } from "../Interfaces"
import { ComponentTestingCreation } from "./ComponentTestingCreation"

import styles from "../PredictionCreationFlow.module.scss"

export const ComponentTestingDialog = ({
  isOpen,
  handleClose,
  selectedComponent,
}: {
  isOpen: boolean
  handleClose: () => void
  selectedComponent: SelectedComponent
}): ReactElement => {
  const { t } = useTranslation("predictions", {
    keyPrefix: "componentTestingDialog",
  })
  const theme = getTheme()
  return (
    <Drawer
      open={isOpen}
      onClose={() => {
        handleClose()
      }}
      anchor="right"
      PaperProps={{ className: styles.drawerPaper }}
    >
      <Grid container display={"flex"} flexDirection={"column"} height={"100%"}>
        <Grid item className={styles.drawerHeader}>
          <Typography variant="h3-bold">{t("title")}</Typography>

          <IconButton
            onClick={() => {
              handleClose()
            }}
            size="small"
            className={"close-icon-button"}
          >
            <CloseIcon style={{ color: theme.palette.base.text[3] }} />
          </IconButton>
        </Grid>
        <Grid item container width={"100%"} display={"flex"} flex={1} p={2} style={{ overflowY: "auto" }}>
          <ComponentTestingCreation selectedComponent={selectedComponent} />
        </Grid>
      </Grid>
    </Drawer>
  )
}
